import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'chip-specs',
  templateUrl: './chip-specs.component.html',
  styleUrls: ['./chip-specs.component.sass']
})
export class ChipSpecsComponent implements OnInit {

  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/chip/';

  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
